import { useState, useEffect } from "react";
import styles from "./ForgotPassword.module.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import {
  forgotPassword,
  clearError,
  clearForgotState,
} from "../../../store/slices/authSlice";
import { toast } from "react-toastify";

const DEFAULT_COUNTRY = "EG";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { otpLoading, forgotOtpSent, error } = useSelector((s) => s.auth);

  const [phone, setPhone] = useState("");
  const [localError, setLocalError] = useState("");

  useEffect(() => {
    if (!forgotOtpSent) return;
    dispatch(clearForgotState());
    toast.success(" تم إرسال كود التحقق على بريدك!", {
      autoClose: 2000,
      position: "top-center",
    });
    navigate("/forgot-verify-otp", { state: { phone } });
  }, [forgotOtpSent]);

  useEffect(() => {
    if (!error) return;
    toast.error(
      ` ${typeof error === "string" ? error : "البريد الإلكتروني غير مسجل"}`,
      {
        position: "top-center",
      },
    );
    dispatch(clearError());
  }, [error, dispatch]);

  const handlePhoneChange = (value) => {
    setPhone(value || "");
    if (localError) setLocalError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLocalError("");

    if (!phone) {
      setLocalError("رقم الهاتف مطلوب");
      return;
    }
    if (!isValidPhoneNumber(phone)) {
      setLocalError("يرجى إدخال رقم هاتف صحيح");
      return;
    }

    dispatch(forgotPassword(phone));
  };

  return (
    <div className={styles.ForgotContainer}>
      <div className={styles.ForgotCard}>
        <img src="/logo raw-kemya.jfif" className="brand-logo" alt="logo" />
        <h2>{t("forgotPassword.title")}</h2>
        <p className={styles.desc}>{t("forgotPassword.desc")}</p>

        {localError && <div className={styles.errorBanner}> {localError}</div>}

        <form onSubmit={handleSubmit} noValidate>
          <div className={styles.inputGroup}>
            <label htmlFor="phone">
              {t("forgotPassword.phone") || "رقم الهاتف"}
            </label>

            <div className={styles.phoneInputWrap} dir="ltr">
              <PhoneInput
                id="phone"
                defaultCountry={DEFAULT_COUNTRY}
                international
                countryCallingCodeEditable={false}
                value={phone}
                onChange={handlePhoneChange}
                placeholder={t("forgotPassword.phone") || "رقم الهاتف"}
              />
            </div>
          </div>

          <button
            type="submit"
            className={`${styles.button} ${styles.buttonForgot}`}
            disabled={otpLoading}
          >
            {otpLoading
              ? " جاري الإرسال..."
              : t("forgotPassword.sendCode") || "إرسال كود التحقق"}
          </button>
        </form>

        <button
          type="button"
          className={styles.backLink}
          onClick={() => navigate("/login")}
        >
          ← {t("forgotPassword.backToLogin") || "العودة لتسجيل الدخول"}
        </button>
      </div>
    </div>
  );
}
